module.exports = __webpack_public_path__ + "img/account-group.e4c253f9.svg";